import type { User } from './user.types'

export enum DocumentLiveStatus {
  Staging = 0,
  Live = 1,
  Archived = 2,
}
export enum DocumentStagingStatus {
  PendingUpload = 0,
  Draft = 1,
  InternalReview = 2,
  ConsultantReview = 3,
  AuditReady = 4,
  Final = 5,
}

export enum DocumentType {
  Policy = 1,
  SOP = 2,
  ProcessDiagram = 3,
  WorkInstruction = 4,
  FormsTemplatesLogs = 5,
}

export type Document = {
  id: number
  title: string
  titleId?: string
  docNumberTemplate: string
  liveDocNumber?: string
  docType: DocumentType
  departmentId: number
  picUserId: number
  stagingStatus: DocumentStagingStatus
  stagingFileId: number
  liveStatus: DocumentLiveStatus
  liveFileId: number
  stagingFile?: File
  liveFile?: File
  createTs: string | Date
  updateTs: string | Date
  picUser?: Pick<User, 'email' | 'id' | 'name' | 'role'>
  controlDocumentMap?: {
    controlId: number
    documentId: number
  }[]
  department?: {
    id: number
    title: string
  }
}

export type File = {
  id: number
  documentId: number
  uploaderId: number
  storagePrefix: string
  fileHash: string
  fileSize: number
  mimeType: string
  fileName: string
  version: number
  revision?: number
  docNumberSnapshot?: string
  revLabel?: string
  uploadTs: string | Date
}
